<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta
      name="description"
      content="Free, open-source AI agent harness. Type1Skills classifies every decision as reversible or irreversible, maintains audit trails, and keeps high-stakes AI workflows under control. MIT-licensed."
    />
    <meta name="keywords" content="AI agent harness, auditable AI workflows, reversible AI decisions, open source AI workflow, Type 1 decisions, AI governance, agent orchestration, free AI developer tools" />
    <meta property="og:title" content="Type1Skills — Free Open-Source AI Agent Harness" />
    <meta
      property="og:description"
      content="The free, open-source harness that gives AI agents a decision spine. Reversible paths tracked. Irreversible ones flagged. Every operation auditable. MIT-licensed and community-driven."
    />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://www.type1skills.com" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Type1Skills — Free Open-Source AI Agent Harness" />
    <meta name="twitter:description" content="Free, MIT-licensed harness for auditable, reversible AI agent workflows. Separate one-way doors from two-way doors in every AI operation." />
    <link rel="canonical" href="https://www.type1skills.com" />
    <title>Type1Skills — Free Open-Source AI Agent Harness for Auditable Workflows</title>
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "Type1Skills",
      "alternateName": "T1Skills",
      "description": "Free, open-source AI agent harness that classifies every decision as reversible or irreversible, maintains audit trails, and enforces decision discipline for high-stakes AI workflows. Based on Jeff Bezos's Type 1 / Type 2 decision framework.",
      "url": "https://www.type1skills.com",
      "applicationCategory": "DeveloperApplication",
      "operatingSystem": "Linux, macOS, Windows",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD"
      },
      "license": "https://opensource.org/licenses/MIT",
      "codeRepository": "https://github.com/vibelibs/type1skills",
      "keywords": "AI agent harness, auditable AI, reversible decisions, open source AI workflow, Type 1 decisions, AI governance, agent orchestration"
    }
    </script>
  </head>
  <body>
    <div id="root"></div>
    <script type="module" src="/src/main.tsx"></script>
  </body>
</html>
